import { createColumnHelper } from "@tanstack/react-table";
import { useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import DataTable from "../../../../components/dataTable/DataTable";
import { reqGetNew, ApiEndpoints } from "../../../../config/apiClient";
import ModalEscalaTipoFormModal from "./ModalEscalaTipoForm";

export default function EscalasTiposPage() {
    useEffect(() => {
        document.title = "Escalas Tipos | OB PORTUS";
        listarRegistros();
        // eslint-disable-next-line
    }, []);

    const [loading, setLoading] = useState<boolean>(false);
    const [dados, setDados] = useState<any[]>([]);
    const [showModalEscalaTipo, setShowModalEscalaTipo] = useState<boolean>(false);
    const [tipoEscala, setSelecionarTipo] = useState<any>({})

    async function listarRegistros() {
        setLoading(true);
        const api = await reqGetNew(ApiEndpoints.pontoTiposEscalas);
        if (api.status === 200) {
            setDados(api.data);
        }
        setLoading(false);
    }

    function tableMiddleClickhandler(event: any) {
        const idx = Number(event.target.parentElement.getAttribute("about"));
        const reg: any = dados[idx];
        setSelecionarTipo(reg)
        setShowModalEscalaTipo(true)
    }

    function tableClickhandler(event: any) {
        const idx = Number(event.target.parentElement.getAttribute("about"));
        const reg: any = dados[idx];
        setSelecionarTipo(reg)
        setShowModalEscalaTipo(true)
    }

    function handleCloseModal() { 
        setSelecionarTipo({})
        setShowModalEscalaTipo(false)
    }
    function handleUpdateModal() { 
        handleCloseModal()
        listarRegistros()
    }

    return (
        <div id="main">
            <ModalEscalaTipoFormModal show={showModalEscalaTipo} escalaTipo={tipoEscala} handleClose={() => handleCloseModal()} handleUpdate={()=>handleUpdateModal()} />
            <div className="div-row-space-between">
                <h1 id="titleMain" style={{ marginRight: "10px" }}>
                    Tipos de Escalas
                </h1>
                <Button onClick={() => {setShowModalEscalaTipo(true)}}>Cadastrar</Button>
            </div>
            <br></br>
            {loading && <Spinner />}
            {!loading && <DataTable dados={dados} tableSize={"auto"} defaultColumns={defaultColumns} tableMiddleClickhandler={tableMiddleClickhandler} tableClickhandler={tableClickhandler} defaultOrder={defaultOrder} defaultRows={50} />}
        </div>
    );
}

const columnHelper = createColumnHelper<any>();
const defaultColumns = [
    columnHelper.accessor((row) => row.id_tipo, {
        header: "ID TIPO",
        size: 50,
    }),
    columnHelper.accessor((row) => row.descricao, {
        header: "Descrição",
        size: 250,
    }),
];
const defaultOrder: any[] = [];
